<template>
  <div class="d-flex align-center justify-space-between py-4">
    <div class="title d-flex align-center">
      <v-btn icon @click="$emit('btn-expand-click')">
        <v-icon
          >{{ expand ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
        </v-icon>
      </v-btn>
      <div class="form-base__title">{{ title }}</div>
    </div>

    <v-btn
      v-if="btnDeleteVisible"
      @click="$emit('btn-delete-click')"
      depressed
      class="button-base-white button-base"
    >
      {{ btnDeleteText }}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'ItemHeader',
  props: {
    expand: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    btnDeleteVisible: {
      type: Boolean,
      required: true,
    },
    btnDeleteText: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.title {
  min-height: 50px;
}
</style>
